const DEFAULT_ORIGIN = "https://meowmitattoo.com";

export const SHARE_REF_PARAM = "?ref=share";

function resolveOrigin(origin) {
  const raw = origin || process.env.NEXT_PUBLIC_BASE_URL || DEFAULT_ORIGIN;
  return raw.replace(/\/$/, "");
}

export function buildAbsoluteUrl(pathname, origin) {
  if (typeof pathname !== "string") return "";
  if (/^https?:\/\//i.test(pathname)) return pathname;
  const clean = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${resolveOrigin(origin)}${clean}`;
}

const KIND_PATHS = {
  artwork: "artwork",
  sticker: "stickers",
};

export function buildShareUrl({ kind, id, origin } = {}) {
  if (!id) throw new Error("id required");
  const base = KIND_PATHS[kind];
  if (!base) throw new Error(`unknown kind: ${kind}`);
  return `${resolveOrigin(origin)}/${base}/${encodeURIComponent(id)}${SHARE_REF_PARAM}`;
}
const KIND_LABEL = {
  artwork: "認領圖",
  sticker: "紋身貼紙",
};

export function buildSharePayload({ artwork, kind, origin } = {}) {
  if (!artwork) throw new Error("artwork required");
  if (!artwork.name) throw new Error("artwork.name required");
  const label = KIND_LABEL[kind];
  if (!label) throw new Error(`unknown kind: ${kind}`);
  return {
    title: `${artwork.name} — 咪室刺青`,
    text: `發現一張超可愛的${label}`,
    url: buildShareUrl({ kind, id: artwork.id, origin }),
  };
}
export function buildIntentUrl({ platform, shareUrl, title = "" } = {}) {
  if (!shareUrl) throw new Error("shareUrl required");
  const composed = `${title} ${shareUrl}`.trim();
  switch (platform) {
    case "line":
      return `https://line.me/R/msg/text/?${encodeURIComponent(composed)}`;
    case "whatsapp":
      return `https://wa.me/?text=${encodeURIComponent(composed)}`;
    case "telegram":
      return `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}`;
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    case "threads":
      return `https://threads.net/intent/post?text=${encodeURIComponent(composed)}`;
    case "x":
      return `https://x.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(shareUrl)}`;
    case "email":
      return `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(shareUrl)}`;
    default:
      throw new Error(`unknown platform: ${platform}`);
  }
}
